<template>
  <div class="interiorzone">
    <div class="toptit"><h2 class=" fl subheading">路由设置</h2><button @click="addbank()">增加银行</button><button class="interest" @click="openinterest()">利差设置</button><button @click="advertisinga()">广告设置</button></div>
    <div class="contentbox">
      <div class="content-bankset-listbox">
        <ul class="headtou">
          <li>序号</li>
          <li>银行名称</li>
          <li>额度设置</li>
          <li>单笔额度</li>
          <li>运营设置</li>
          <li>运营通知</li>
          <li>操作</li>
        </ul>
        <ul v-for="(bl,index) in banklist" v-bind:key="index">
          <li>{{index+1}}</li>
          <li>{{bl.bankName}}</li>
          <li>{{bl.totalLimit|money}}元</li>
          <li>{{bl.singleLimit|money}}元</li>
          <li><span @click="openmarketing(index)" class="pointer">设置</span></li>
          <li><span @click="openNewMark(index)" class="pointer">设置</span></li>
          <li><span @click="setbank(index)" class="pointer">修改</span>|<span class="pointer" @click="alertdel(bl.bankNo)">删除</span></li>
        </ul>
        <div class="chaBox">
          <el-dialog
            title="设置运营通知-网商银行"
            :visible.sync="showModal"
            width="60%"
            :before-close="handleClose">
            <div class="butBox">
                <el-button class="but2" @click="handleAddNew()">新增</el-button>
                <!-- <el-button type="primary" class="but2" @click="handleSaveNew">保存</el-button> -->
            </div>
            <div class="tableBox">
              <el-table
                :data="tableData"
                style="width: 100%">
                <el-table-column
                  prop="name"
                  label="序号"
                  >
                </el-table-column>
                <el-table-column
                  prop="bankNotice"
                  label="内容"
                  width="260">
                </el-table-column>
                <el-table-column
                  prop="noticeStartTime"
                  label="开始时间">
                </el-table-column>
                <el-table-column
                  prop="noticeEndTime"
                  label="截止时间">
                </el-table-column>
                <el-table-column
                  prop="modifyTime"
                  label="创建/修改时间">
                </el-table-column>
                <el-table-column
                  label="操作">
                  <template slot-scope="scope">
                    <div>
                        <el-button @click="handleAddNew(scope.row)" type="text" size="small">编辑</el-button>
                        <el-button @click="handleClick(scope.row)" type="text" size="small">删除</el-button>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-dialog>
        </div>
        <el-dialog
            title=""
            :visible.sync="showChlModal"
            width="30%"
            append-to-body
            :before-close="handleCloseChl">
            <div class="textBox">
              <el-input
                type="textarea"
                placeholder="请输入内容"
                v-model="textareaNewVal"
                show-word-limit
              >
              </el-input>
              <div class="dateBox">
                <el-date-picker
                  v-model="value1"
                  type="daterange"
                  format="yyyy-MM-dd" 
                  value-format="yyyy-MM-dd"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期">
                </el-date-picker>
              </div>
              <div class="savBox">
                <el-button type="primary" class="but2" @click="handleSaveNew">保存</el-button>
              </div>
            </div>
          </el-dialog>
        <ul class="listpage" v-if="ifpageshow">
          <li @click="loadata(1)">首页</li> <!--这里是1-->
          <li v-for="(item,index) in pagenum" v-bind:key="index" :class="currentPage==item?'active':''"  @click="nextpage(item)">{{item}}</li>
          <li @click="loadata(total)">尾页</li><!--这里是pagenum-->
        </ul>
      </div>
    </div>
    <div class="zzc" v-if="interestpanel">
      <div class="banksetpanel setinterest">
        <h2>利差设置</h2>
        <div class="banksetbox">
          <div class="bankinputbox">
            <label>银行利差</label>
            <input type="text" v-model="basispoint">
            <span>BP</span>
          </div>
          <div class="savebox">
            <div class="tosave"  @click="saveinterest()">保存</div>
            <div class="tocanel" @click="coloseinterest()">取消</div>
          </div>
        </div>
      </div>
    </div>

    <div class="zzc" v-if="setmarketingpoint">
      <div class="banksetpanel marketing">
        <h2>运营利率设置</h2> 
        <div class="banksetbox">
            <label>{{nowbank}}银行利差</label>
          <!-- <div class="bankinputpanel">
            <label>活动期限</label>
            <el-date-picker v-model="marketingstart"  type="daterange" format="yyyy-MM-dd" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </div> -->
          <div class="bankinputpanel ododod">
            <label>起止日期</label>
              <div v-for="(it,index) in orrList" :key="index">
                <div class="lofas">
                  <input type="text" class="uouou" v-model="it.subBp">
                  <span class="dodo">BP</span>
                </div>
                <div class="lofas">
                  <el-time-select
                    placeholder="起始时间"
                    v-model="it.startTime"
                    :picker-options="{
                      start: '00:00',
                      step: '00:30',
                      end: '24:00'
                    }">
                  </el-time-select>
                </div>
                <div class="lofas">
                  <el-time-select
                    placeholder="结束时间"
                    v-model="it.endTime"
                    :picker-options="{
                      start: '00:00',
                      step: '00:30',
                      end: '24:00',
                      minTime: startTime
                    }">
                  </el-time-select>
                </div>
                <div class="adds" @click="adds">+</div>
                <!-- <div class="adds">-</div> -->
              </div>
          </div>
          <div class="bankinputpanel">
            <label>工作时间（如工作日08:30-17:00）</label>
            <el-input v-model="inputVal" placeholder="请输入内容"></el-input>
          </div>
          <div class="bankinputpanel">
            <label>其他说明（如允许回头，非工作日允许贴现等）</label>
            <el-input
              type="textarea"
              placeholder="请输入内容"
              v-model="textareaVal"
              show-word-limit
            >
            </el-input>
          </div>
          <div class="poiu">
            <el-upload
              class="upload-demo"
              action="https://jsonplaceholder.typicode.com/posts/"
              :http-request="uploadFileRng"
              :limit=1
              >
              <el-button size="small" type="primary">上传《操作手册》</el-button>
            </el-upload>
          </div>
          <div class="savebox">
            <div class="tosave"  @click="savemarketing()">保存</div>
            <div class="tocanel" @click="colosemarketing()">取消</div>
          </div>
        </div>
      </div>
    </div>
    <div class="zzc" v-if="advpanel">
      <div class="advsetpanel">
        <h2>广告语设置</h2>
        <div class="banksetbox">
          <el-input type="textarea" class="moreline" :rows="6"  placeholder="请输入内容" v-model="textarea"></el-input>
          <div class="bankinputbox  mgmgt">
              <el-radio v-model="adid" label="1" class="fl">应用于H5</el-radio>
              <el-radio v-model="adid" label="2" class="fl">应用于小程序</el-radio>
              <el-radio v-model="adid" label="3" class="fl">H5、小程序同步使用</el-radio>
          </div>
          <div class="savebox">
            <div class="tosave"  @click="setadv">保存</div>
            <div class="tocanel" @click="closeadv">取消</div>
          </div>
        </div>
      </div>
    </div>
    <div class="zzc" v-if="isbankpanel">
      <div class="banksetpanel">
        <h2>{{setoradd}}</h2>
        <div class="banksetbox">
          <div class="bankinputbox">
            <label>银行名称</label>
            <input type="text" v-model="setbankname">
          </div>
          <div class="bankinputbox">
            <label>优先级</label>
            <div><div class="rangebox"><span class="count-l" alt='减' title="减" @click="subtraction()"></span>{{rangeboxval}}<span class="count-r" alt='加' title="加" @click="addition()">+</span></div><div class="solidrange"><span>0</span><input type="range" min="0" max="100" step="1" :autocomplete="rangeboxval" v-model="rangeboxval" ><span>100</span></div></div>
          </div>
          <div class="bankinputbox">
            <label>满额限额</label>
            <input type="text" v-model="fullquota" ref="inputa" @blur="tofilter(1)">
            <div class="filterpanel" v-if="isfousa==false" @click="fullfous()">{{fullquota|money}}</div>
          </div>
          <div class="bankinputbox">
            <label>单笔限额</label>
            <input type="text" v-model="singlequota"  ref="inputb"  @blur="tofilter(2)">
            <div class="filterpanel"  v-if="isfousb==false" @click="singlefous()">{{singlequota|money}}</div>
          </div>
          <div class="savebox">
            <div class="tosave" v-if="setoradd=='增加银行'"  @click="addbankdata()">保存</div>
            <div class="tosave" v-else @click="upbankdata">保存</div>
            <div class="tocanel" @click="closebankpanel">取消</div>
          </div>
        </div>
      </div>
    </div>
    <div class="zzc" v-if="delpanel">
      <div class="delalert">
        <p>删除后不可恢复，您是否确认删除？</p>
        <div class="bottombtnbox">
          <div class="nobtn" @click="bankclera()">删除</div>
          <div class="okbtn" @click="closedelpanel()">取消</div>
        </div>
      </div>
    </div>
  </div> 
</template>
<script>
var date=new Date()
var year = date.getFullYear();
var month = date.getMonth()+1 ;
var nextmonth=month+1
var day = date.getDate();
if (month < 10) {
    month = "0" + month;
  }
if (nextmonth < 10) {
    nextmonth = "0" + nextmonth;
  }
if (day < 10) {
  day = "0" + day;
}
var nowday=year+'-'+month+'-'+day
var nownextmoth=year+'-'+nextmonth+'-'+day
export default {
  data() {
    return {
      banklist:[],
      pagenum:0,
      currentPage:1,
      pageSize:10,
      ifpageshow:false,
      delpanel:false,
      setoradd:"增加银行",
      rangeboxval:10,
      isbankpanel:false,
      setbankname:'',
      fullquota:'',
      singlequota:'',
      isfousa:false,
      isfousb:false,
      noweditid:0,
      interestpanel:false,
      basispoint:'0',
      nowbank:'',
      marketingpoint:'',
      marketingstart:[nowday,nownextmoth],
      setmarketingpoint:false,
      nowbankid:'',
      advpanel:false,
      textarea:'',
      coloregg:3,
      adid:'1',
      inputVal:'',
      textareaVal:'',
      dialogImageUrl:'',
      showModal:false,
      tableData: [{
            date: '2016-05-02',
            name: '王小虎',
            address: '上海市普陀区金沙江路 1518 弄'
          }],
      showChlModal:false,
      textareaNewVal:'',
      value1:[],
      orNo:'',
      orId:'',
      bigNo:'',
      startTime: '',
      endTime: '',
      startTime1:'',
      endTime1:'',
      orrList:[]
    }
  },
  watch:{
    adid(val){
      if(this.interestpanel){
        if(this.adid=='1'){
          this.advertisinga()
        }
        else if(this.adid=='2'){
          this.advertisingb()
        }
      }
    }
  },
  mounted:function() {
    this.getlist()
  },
  methods:{
    getlist(){
      this.ajax.post('/discountBank/getList',{bizContent:{limit:this.pageSize,page:this.currentPage}})
      .then(
        res=>{
          this.banklist=res.data.data.data
        }
      )
    },
    nextpage(item){
      this.currentPage=item
      this. readlist()
    },
    fullfous(){
      this.isfousa=true
      this.$refs.inputa.focus();
    },
    tofilter(val){
      if(val==1){
        this.isfousa=false
      }
      else if(val==2){
        this.isfousb=false
      }
    },
    singlefous(){
      this.isfousb=true
      this.$refs.inputb.focus();
    },
    openinterest(){
      this.ajax.post(this.versatile.oaurl+'/system/getsystem',{bizContent:{name: "comparerate"}})
      .then(
        result=>{
          if(result.data.status=='0000'){
            this.basispoint=result.data.data.value
          }
          else{
            swal({
                text: result.data.message,
                timer: 3000,
                buttons: false
              })
          }
        }
      )
      this.interestpanel=true
    },
    coloseinterest(){
      this.interestpanel=false
    },
    openmarketing(key){
      this.setmarketingpoint=true
      this.nowbank=this.banklist[key].bankName
      this.nowbankid=this.banklist[key].bankNo
      this.inputVal=this.banklist[key].workTime
      this.textareaVal=this.banklist[key].otherInstructions
      this.dialogImageUrl=this.banklist[key].manualRrl
      this.orrList=this.banklist[key].actList
      // this.startTime=this.orrList[0].startTime
      // this.endTime=this.orrList[0].endTime
      // this.marketingpoint=this.orrList[0].subBp
      this.marketingpoint=Number(this.banklist[key].interestRateActivity)/100
      let a=this.$options.filters.formatDate(this.banklist[key].activityStartTime)
      let b=this.$options.filters.formatDate(this.banklist[key].activityEndTime)
      this.$set(this.marketingstart, 0,a)
      this.$set(this.marketingstart, 1,b)
    },
    adds(){
      let arr = this.orrList.length-1;
      console.log(arr,'ssssssssssss')
      let json = this.orrList[arr]
      if(json.subBp==''||json.startTime==''||json.endTime==''){
        return;
      }else{
        let add = {
            subBp:'',
            startTime:'',
            endTime:''
          }
          this.orrList.push(add)
      }
    },
    openNewMark(key){
      console.log(key,'s11')
      if(key!==undefined ){
          this.bigNo = this.banklist[key].bankNo
      }
      this.ajax.post('discountBank/getNoticeList',{bizContent:{bankno:this.bigNo,limit:'10',page:'1'}})
      .then(
        res=>{
            if(res.data.status==='0000'){
              let arr=res.data.data.data
              arr.map((item,index)=>{
                item.name=index+1
              })
              this.tableData=arr
              console.log(arr,'sss')
              this.showModal=true
            }
        }
      )
    },
    handleClose(done) {
        this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {});
    },
    handleCloseChl(done) {
        this.$confirm('确认关闭？')
          .then(_ => {
            this.orId=''
            // this.value1=[]
            this.textareaNewVal=''
            done();
          })
          .catch(_ => {});
    },
    colosemarketing(key){
      this.setmarketingpoint=false
    },
    advertisinga(){
      this.advpanel=true;
      this.ajax.post(this.versatile.oaurl+'/system/getsystem',{bizContent: {name: 'advertising'}})
      .then(
        result=>{
          if(result.data.status=='0000' && JSON.stringify(result.data.data)!="{}"){
            if(result.data.data.value!=null){
              this.textarea=result.data.data.value
            }
          }
        }
      )
    },
    advertisingb(){
      this.advpanel=true;
      this.ajax.post(this.versatile.oaurl+'/system/getsystem',{bizContent: {name: 'miniprogram'}})
      .then(
        result=>{
          if(result.data.status=='0000' && JSON.stringify(result.data.data)!="{}"){
            if(result.data.data.value!=null){
              this.textarea=result.data.data.value
            }
          }
        }
      )
    },
    savemarketing(){
      this.ajax.post('/discountBank/updateActivityRate',{bizContent:
      {bankNo:this.nowbankid,interestRateActivity:this.marketingpoint,activityStartTime:this.marketingstart[0],activityEndTime:this.marketingstart[1],
      worktime:this.inputVal,otherinstructions:this.textareaVal,manualurl:this.dialogImageUrl,name:this.nowbank,list:this.orrList}})
      .then(
        result=>{
          if(result.data.status=='0000'){
            this.setmarketingpoint=false
            swal({
              text: '运营利率设置成功',
              icon: "success",
              timer: 3000,
              buttons: false
            })
            this.getlist()
          }
          else{
            swal({
              text: result.data.message,
              timer: 3000,
              buttons: false
            })
          }
        }
      )
    },
    saveinterest(){
      this.ajax.post(this.versatile.oaurl+'/system/updatesystem',{bizContent: {name:'comparerate',value:this.basispoint}})
      .then(
        result=>{
          if(result.data.status=='0000'){
            this.interestpanel=false
            swal({
              text: '利差设置成功',
              icon: "success",
              timer: 3000,
              buttons: false
            })
          }
          else{
            swal({
              text: result.data.message,
              timer: 3000,
              buttons: false
            })
          }
        }
      )
      
    },
    addbank(){
      this.setoradd="增加银行"
      this.isbankpanel=true
      this.setbankname=''
      this.rangeboxval=0
      this.fullquota=''
      this.singlequota=''
    },
    setbank(val){
      this.setoradd="设置银行"
      this.isbankpanel=true
      let bankdata=this.banklist[val]
      console.log(bankdata)
      this.setbankname=bankdata.bankName
      this.rangeboxval=bankdata.weight
      this.fullquota=bankdata.totalLimit
      this.singlequota=bankdata.singleLimit
      this.noweditid=bankdata.bankNo
    },
    upbankdata(){
      if(this.setbankname==''){
        swal({
              text: "银行名称不能为空",
              timer: 3000,
              buttons: false
            })
      }
      else if(this.totalLimit==''){
        swal({
          text: "满额限额不能为空",
          timer: 3000,
          buttons: false
        })
      }
      else if(this.singleLimit==''){
        swal({
          text: "单笔限额不能为空",
          timer: 3000,
          buttons: false
        })
      }
      else{
        this.ajax.post("/discountBank/update",{bizContent:{bankNo:this.noweditid,bankName:this.setbankname,totalLimit:this.fullquota,singleLimit:this.singlequota,weight:this.rangeboxval}})
        .then(
          result=>{
            if(result.data.status=="0000"){
              this.getlist()
              this.isbankpanel=false
            }
            else{
              swal({
                text: result.data.message,
                timer: 3000,
                buttons: false
              })
            }
          }
        )
      }
    },
    subtraction(){
      if(this.rangeboxval!=0){
        this.rangeboxval= Number(this.rangeboxval)-1
      }
    },
    addition(){
      if(this.rangeboxval!=100){
      this.rangeboxval= Number(this.rangeboxval)+1
      }
    },
    addbankdata(){
      //更新银行信息提交到数据库
      if(this.setbankname==''){
        swal({
              text: "请填写银行名称",
              timer: 3000,
              buttons: false
            })
      }
      else if(this.totalLimit==''){
        swal({
          text: "请填满额限额",
          timer: 3000,
          buttons: false
        })
      }
      else if(this.singleLimit==''){
        swal({
          text: "请填写单笔限额",
          timer: 3000,
          buttons: false
        })
      }
      else{
        this.ajax.post('/discountBank/add',{bizContent:{bankName:this.setbankname,totalLimit:this.fullquota,singleLimit:this.singlequota,weight:this.rangeboxval}})
        .then(
          result=>{
            if(result.data.status=="0000"){
              this.isbankpanel=false
              this.getlist()
            }
            else{
              swal({
                text: result.data.message,
                timer: 3000,
                buttons: false
              })
            }
          }
        )
      }
    },
    setadv(){
      if(this.adid==1){
        this.seth5()
      }
      else if(this.adid==2){
        this.setminiprogram()
      }
      else if(this.adid==3){
        this.seth5()
        this.setminiprogram()
      }
    },
    seth5(){
      this.ajax.post(this.versatile.oaurl+'/system/updatesystem',{bizContent:{name:"advertising",value:this.textarea}})
        .then(
          result=>{
            if(result.data.status=="0000"){
              swal({
                text: '提交成功',
                icon: "success",
                timer: 3000,
                buttons: false
              })
              this.advpanel=false
            }
            else{
              swal({
                text: result.data.message,
                timer: 3000,
                buttons: false
              })
            }
          }
        )
    },
    setminiprogram(){
      this.ajax.post(this.versatile.oaurl+'/system/updatesystem',{bizContent:{name:"miniprogram",value:this.textarea}})
        .then(
          result=>{
            if(result.data.status=="0000"){
              swal({
                text: '提交成功',
                icon: "success",
                timer: 3000,
                buttons: false
              })
              this.advpanel=false
            }
            else{
              swal({
                text: result.data.message,
                timer: 3000,
                buttons: false
              })
            }
          }
        )
    },
    closeadv(){
      this.advpanel=false
    },
    closebankpanel(){
      this.isbankpanel=false
      this.setbankname=''
      this.rangeboxval=0
      this.fullquota=''
      this.singlequota=''
      this.inputVal=''
      this.textareaVal=''
      this.dialogImageUrl=''
    },
    alertdel(val){
      this.delpanel=true
      this.noweditid=val
    },
    closedelpanel(){
      this.delpanel=false
    },
    bankclera(){
      this.ajax.post("/discountBank/del",{bizContent:{bankNo:this.noweditid}}).then(
        result=>{
          if(result.data.status=="0000"){
              this.delpanel=false
              this.getlist()
            }
            else{
              swal({
                text: result.data.message,
                timer: 3000,
                buttons: false
              })
            }
        }
      )
    },
    uploadFileRng(item){
        const fileObj = item.file
            // FormData 对象
        const form = new FormData()
            // 文件对象
        form.append('file', fileObj)
        this.ajax.post(this.versatile.oaurl+'/upload/fastdfsUpload',form)
                    .then(
                        result=>{
                            if(result.data.status=='0000'){
                                let url = result.data.data
                                this.dialogImageUrl=url
                            }else{
                                this.$message(result.message);
                            }
                        }
            )
    },
    handleAddNew(val){
      console.log(val,'~~~~~~~~~~~')
      this.value1=[]
      if(val&&val.bankNotice){
        this.orId=val.id
        this.textareaNewVal=val.bankNotice
        this.value1[0]=val.noticeStartTime
        this.value1[1]=val.noticeEndTime
        console.log(this.value1,'dddddddddddddd')
      }
      this.showChlModal=!this.showChlModal
    },
    handleClick(val){
      this.$confirm('您确定要删除么?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.ajax.post('/discountBank/delNotice',{bizContent:{id:val.id}})
                .then(
                  res=>{
                      if(res.data.status==='0000'){
                          this.$message('删除成功！')
                          this.openNewMark()
                      }else{
                          this.$message(res.data.message)
                      }
                  }
                )
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
    },
    handleSaveNew(){
        this.ajax.post('/discountBank/updateBankNotice',{bizContent:{bankNo:this.bigNo,id:this.orId,banknotice:this.textareaNewVal,noticestarttime:this.value1[0],noticeendtime:this.value1[1]}})
        .then(
          res=>{
              if(res.data.status==='0000'){
                  this.orId=''
                  this.textareaNewVal=''
                  this.value1=[]
                  this.$message('保存成功！')
                  this.openNewMark()
                  this.showChlModal=!this.showChlModal
              }else{
                  this.$message(res.data.message)
              }
          }
        )
    }
  }
}
</script>

<style scoped>
.toptit{
  width:100%;
  display:table;
  clear:both;
  margin-bottom:20px;
}
.toptit button{
  float:left;
  margin-left:30px;
  width:111px;
  height:39px;
  background:rgba(61,143,226,1);
  box-shadow:0px 2px 7px 0px rgba(61,143,226,0.43);
  border-radius:2px;
  color:#fff;
  margin-top:3px;
  cursor:pointer;
}
.content-bankset-listbox,.content-bankset-listbox ul{
  clear:both;
  width:100%;
  display:table;
  margin:0 auto;
}
.content-bankset-listbox ul{
  height:90px;
  line-height:90px
}
.content-bankset-listbox ul.headtou{
  height:56px;
  line-height:56px;
  background:#FCFCFC;
}
.content-bankset-listbox ul li{
  float:left;
  text-align:center;
  font-size:14px;
  width:14.6%;
}
.content-bankset-listbox ul li:nth-child(1){
  width:10%;
}
.content-bankset-listbox ul li:last-child{
  color:#dfdfdf;
}
.content-bankset-listbox ul:first-child li:last-child{
  color:#333333;
}
.content-bankset-listbox ul li span:first-child{
  margin-right:10px;
  color:#3D8FE2
}
.content-bankset-listbox ul li span:last-child{
  margin-left:10px;
  color:#3D8FE2
}
.delalert{
  position:absolute;
  left:50%;
  top:50%;
  width:308px;
  height:157px;
  margin-left:-154px;
  margin-top:-78px;
  background:rgba(255,255,255,1);
  box-shadow:0px 1px 6px 0px rgba(0,0,0,0.08);
}
.delalert p{
  margin-top:40px;
  font-size:14px;
  text-align:center;
}
.modalitbtn{
  width:123px;
  height:40px;
  border-radius:2px;
}
.modalitbtn.ok{
  color:rgba(61,143,226,1);
  box-shadow:0px 2px 8px 1px rgba(61,143,226,0.28);
  border:1px solid rgba(61,143,226,1);
  background:rgba(255,255,255,1);
}
.modalitbtn.no{
  color:#fff;
  background:rgba(61,143,226,1);
  box-shadow:0px 2px 8px 1px rgba(61,143,226,0.28);
}
.bottombtnbox{
  display:table;
  height:40px;
  margin:0 auto;
  margin-top:30px;
}
.nobtn{
  width:123px;
  height:40px;
  line-height:40px;
  text-align:center;
  color:rgba(61,143,226,1);
  background:rgba(255,255,255,1);
  box-shadow:0px 2px 8px 1px rgba(61,143,226,0.28);
  border-radius:2px;
  border:1px solid rgba(61,143,226,1);
  float:left;
  margin-right:10px;
}
.okbtn{
  width:123px;
  height:42px;
  line-height:42px;
  text-align:center;
  color:#fff;
  background:rgba(61,143,226,1);
  box-shadow:0px 2px 8px 1px rgba(61,143,226,0.28);
  border-radius:2px;
  float:left;
}
.banksetpanel{
  width:574px;
  height:auto;
  background:rgba(255,255,255,1);
  box-shadow:0px 1px 14px 2px rgba(0,0,0,0.09);
  position:absolute;
  padding-bottom: 15px;
  left:50%;
  top:50%;
  margin-left:-287px;
  margin-top:-323px;
}
.advsetpanel{
  width:574px;
  min-height:400px;
  vertical-align: middle;
  background:rgba(255,255,255,1);
  box-shadow:0px 1px 14px 2px rgba(0,0,0,0.09);
  position: absolute;
  display: table;
  top: 50%;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  z-index: 19;
  padding-bottom: 20px;
  margin-top:-300px;

}
.banksetpanel h2,.advsetpanel h2{
  width:574px;
  height:64px;
  line-height:64px;
  text-align:center;
  color:#fff;
  font-size:20px;
  background:rgba(61,143,226,1);
  margin-bottom:10px;
}
.banksetbox{
  width:428px;
  display:table;
  margin:0 auto;
}
.bankinputbox,.bankinputpanel{
  width:428px;
  height:87px;
  position: relative;
  clear: both;
  display: block;
}
.ododod{
  height: auto!important;
}
.lofas{
  float: left;
  margin-right: 10px;
  margin-bottom: 15px;
  position: relative;
}
.lofas>>>.el-date-editor{
  width: 120px;
}
.dodo{
  position: absolute;
  left: 88px!important;
  top: 2px!important;
  z-index: 100!important;
}
.uouou{
  width: 110px!important;
  height: 40px!important;
  line-height: 40px!important;
}
.bankinputbox label,.bankinputbox input[type="text"],.bankinputpanel label,.bankinputpanel input{
  display:block;
  width:100%;
}
.bankinputbox label,.bankinputpanel label{
  margin-bottom:10px;
  width:160%;
  margin-top:10px;
  font-size:16px;
  color: #888;
}
.bankinputbox input[type="text"],.filterpanel{
  width:420px;
  padding-left:8px;
  font-size:18px;
  height:55px;
  line-height:55px;
  background-color:#F6F8FC;
}
.bankinputpanel input{
  padding-left:8px;
  font-size:18px;
  height:55px;
  line-height:55px;
  background-color:#F6F8FC;
}
.solidrange{
  float: left;
  width:270px;
  padding-top:25px;
  margin-left:10px;
}
.bankinputbox input[type="range"] {
  display:block;
  background-color: #3D8FE2;
  width:200px;
  height:5px;
  border-radius: 5px;
  margin:0 10px;
  -webkit-appearance:none;
}
input[type="range"]::-webkit-slider-thumb {
  -webkit-appearance:none;
  background-color: #49a9ee;
  width:20px;
  height:20px;
  border-radius: 50%;
  border:2px solid white;
  cursor: pointer;
  transition: 0.3s ease-in-out;
}
 input[type="range"]::-webkit-slider-thumb:hover {
  background-color: #fff;
  border:2px solid #49a9ee;
}
input[type="range"]::-webkit-slider-thumb:active {
  transform: scale(1.6);
}
.rangebox{
  width:111px;
  height:55px;
  line-height:55px;
  text-align: center;
  float: left;
  background:rgba(246,248,252,1);
  position: relative;
}
.rangebox .count-l,.rangebox .count-r{
  position: absolute;
  top: 0;
  font-weight: 600;
  color: #3D8FE2;
  cursor: pointer;
  width:20px;
  height:55px;
  display: block;
}
 .count-l{
   left:10px;
 }
  .count-r{
   right:10px;
 }
.solidrange span,.solidrange input{ 
  float: left;
  display: block;
}
.solidrange span{
  margin-top:-10px;
}
.filterpanel{
  position: absolute;
  top:38px;
  right: 0;
}
.poiu{
  height: 60px;
  margin-top: 10px;
}
.savebox{
  display: table;
  margin:0 auto;
  margin-top:18px;
  height:60px;
}
.savebox > div {
  width: 200px;
  height:50px;
  line-height: 50px;
  text-align: center;
  float: left;
  cursor: pointer;
}
.tosave{
  color: #fff;
  background:rgba(61,143,226,1);
  border:1px solid rgba(61,143,226,1);
  box-shadow:0px 2px 8px 1px rgba(61,143,226,0.28);
  border-radius:2px;
  margin-right:20px;
}
.tosave:hover{
  background:rgb(54, 136, 218);
}
.tocanel{
  color: #3D8FE2;
  background-color: #f3f3f3;
  border:1px solid #efefef;
}
.tocanel:hover{
  background:#efefef;
}
.count-l::before{
  content: '';
  width: 8px;
  height: 1.6px;
  position: absolute;
  display: block;
  background-color: #3D8FE2;
  top: 28px;
}
.pointer{
  cursor: pointer;
}
.toptit button.interest{
  background:rgba(255,255,255,1);
  box-shadow:0px 2px 7px 0px rgba(61,143,226,0.43);
  border-radius:2px;
  border:1px solid rgba(61,143,226,1);
  color: #3D8FE2;
}
.setinterest{
  height:420px;
  margin-top:-210px;
}
.setinterest .bankinputbox{
  width:225px;
  position: relative;
  margin-top:30px;
}
.setinterest .bankinputbox input,.smllinput,.smllinput input{
  width:200px;
}
.smllinput{
  height:110px;
}
.setinterest span,.marketing span{
  position: absolute;
  display: block;
  color: #3D8FE2;
  font-size: 20px;
  top: 48px;
  right:30px;
}
.setinterest .savebox{
  margin-top:80px;
}
.bankinputpanel input.bottomless{
  background: #fff;
}
.flf{
  float: left;
  max-width: 160px;
  text-align: center;
}
.moreline{
  margin-top:30px;
}
.adapter{
  float: left;
  color: #999;
  font-size: 20px;
  height:55px;
  line-height:55px;
  font-weight: bold;
  background-color:#F6F8FC;
}
.mgmgt{
  height:30px;
  margin-top:20px;
}
.bankinputbox label{
  width:auto !important;
  display: table;
} 
/* .tableBox{
  height: 280px;
} */
.butBox{
  text-align: left;
  /* margin-top: 120px; */
}
.but1{
    width: 120px;
    height: 40px;
    line-height: 20px;
    border: 1px solid #3D8FE2;
    color: #3D8FE2;
    background: #fff;
}
.but2{
    width: 120px;
    height: 40px;
    line-height: 20px;
    border: 1px solid #3D8FE2;
    color: #fff;
    background: #3D8FE2
}
.chaBox>>>.el-dialog__header{
  background: #3D8FE2;
  text-align: center;
  color: #fff;
}
.chaBox>>>.el-dialog__title{
  color: #fff;
}
.textBox{
  height: 260px;
}
.textBox>>>.el-textarea__inner{
  height: 86px;
}
.dateBox{
  margin-top: 20px;
}
.dateBox>>>.el-date-range-picker{
  width: 540px!important;
}
.savBox{
  text-align: center;
  margin-top: 60px;
}
.adds{
  font-size: 28px;
  color: #333;
  float: left;
  height: 40px;
  line-height: 40px;
}
.adds:hover{
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/page/bankacceptance/bankmanagement.vue